<template functional>
  <a-sub-menu :key="props.menuInfo.functionUid">
    <span slot="title">
      <i class="anticon anticon-environment">
        <span class="iconfont" v-bind:class="props.menuInfo.icon"></span>
      </i>
      <span>{{
        props.menuInfo.funcName == null ? "......" : props.menuInfo.funcName
      }}</span>
    </span>
    <template v-for="item in props.menuInfo.children">
      <a-menu-item v-if="!item.children" :key="item.functionUid">
        <i class="anticon anticon-environment">
          <span class="iconfont" v-bind:class="props.menuInfo.icon"></span>
        </i>
        <span>{{ item.funcName }}</span>
      </a-menu-item>
      <sub-menu v-else :key="item.functionUid" :menu-info="item" />
    </template>
  </a-sub-menu>
</template>
<script>
export default {
  props: ["menuInfo"]
};
</script>
